<div class="table-responsive">
  <table class="table full-width">
    <thead>
      <tr>
        <th>{{ ('Venue_Section.Name' | trans) }}</th>
        <th>{{ ('Venue_Section.Price' | trans) }}</th>
        <th>
          @if (venueSectionAvailable) {
            {{ ('Venue_Section.Available' | trans) }}
          }
        </th>
        <th style="width: 72px"></th>
        <th style="width: 120px">{{ ('Venue_Section.Amount' | trans) }}</th>
        <th style="width: 72px"></th>
      </tr>
    </thead>
    <tbody>
      @if (subscriptionType) {
        @for (subscriptionTypePrice of subscriptionTypePrices; track subscriptionTypePrice; let i = $index) {
          @if (subscriptionTypePrice.priceItems.length) {
            <tr>
              <td>{{ subscriptionTypePrice.name }}</td>
              <td>{{ priceItems[i]?.price | currency }}</td>
              <td>
                @if (venueSectionAvailable) {
                  {{ venueSectionAvailable - amountOfLocalGACapacity }}
                }
              </td>
              <td class="button">
                <cm-button data-button-type="icon" data-icon="remove"
                  (click)="alterTicketTypeAmount(subscriptionTypePrice.id, '-')"
                  [attr.disabled]="!productsAmountSelected[subscriptionTypePrice.id] || productsAmountSelected[subscriptionTypePrice.id] <= 0 ? true : undefined">
                </cm-button>
              </td>
              <td style="width: 80px">
                <div class="form-group">
                  <div class="form-input">
                    <input type="number" min="0" class="form-control input-amount" placeholder="0"
                      [(ngModel)]="productsAmountSelected[subscriptionTypePrice.id]"
                      [max]="venueSectionAvailable - amountOfLocalGACapacity"
                      (input)="inputChanged($event, subscriptionTypePrice.id)">
                  </div>
                </div>
              </td>
              <td class="button">
                <cm-button data-button-type="icon" data-icon="add"
                  (click)="alterTicketTypeAmount(subscriptionTypePrice.id, '+')"
                  [attr.disabled]="shouldDisableAddProductTypeButton(venueSectionAvailable - amountOfLocalGACapacity, subscriptionTypePrice.id) ? true : undefined">
                </cm-button>
              </td>
            </tr>
          }
        }
      }
      <!-- Extra products -->
      @if (productTypePrices) {
        @for (productTypePrice of productTypePrices; track productTypePrice) {
          <tr>
            <td>{{ productTypePrice.name }}</td>
            <td>{{ productTypePrice.priceItem.price | currency: productTypePrice.currency }}</td>
            <td>{{ productTypePrice.available - productsAmountInReservation.get(productTypePrice.id) }}</td>
            <td class="button">
              <cm-button data-button-type="icon" data-icon="remove"
                (click)="alterTicketTypeAmount(productTypePrice.id, '-')"
                [attr.disabled]="!productsAmountSelected[productTypePrice.id] || productsAmountSelected[productTypePrice.id] <= 0 ? true : undefined">
              </cm-button>
            </td>
            <td style="width: 80px">
              <div class="form-group">
                <div class="form-input">
                  <input type="number" min="0"
                    [max]="productTypePrice.available - productsAmountInReservation.get(productTypePrice.id)"
                    class="form-control input-amount"
                    placeholder="0"
                    [(ngModel)]="productsAmountSelected[productTypePrice.id]"
                    (change)="capacityChanged(productTypePrice.id, productTypePrice.available)"
                    (input)="inputChanged($event, productTypePrice.id)">
                </div>
              </div>
            </td>
            <td class="button">
              <cm-button data-button-type="icon" data-icon="add"
                (click)="alterTicketTypeAmount(productTypePrice.id, '+')"
                [attr.disabled]="shouldDisableAddProductTypeButton(productTypePrice.available, productTypePrice.id) ? true : undefined">
              </cm-button>
            </td>
          </tr>
        }
      }
      @for (ticketType of ticketTypes; track ticketType) {
        @if (ticketType.prices[0]) {
          <tr>
            <td>{{ ticketType.name }}</td>
            <td>{{ ticketType.prices[0].price | currency: ticketType.prices[0].currency }}</td>
            <td>
              {{ venueSectionAvailable - amountOfLocalGACapacity }}
            </td>
            <td class="button">
              <cm-button data-button-type="icon" data-icon="remove"
                (click)="alterTicketTypeAmount(ticketType.id, '-')"
                [attr.disabled]="!productsAmountSelected[ticketType.id] || (venueSectionAvailable - this.amountOfLocalGACapacity) <= 0 ? true : undefined">
              </cm-button>
            </td>
            <td class="input">
              <div class="form-group">
                <div class="form-input">
                  <input type="number" min="0" class="form-control input-amount" placeholder="0"
                    [(ngModel)]="productsAmountSelected[ticketType.id]"
                    (input)="inputChanged($event, ticketType.id)"
                    [max]="venueSectionAvailable - this.amountOfLocalGACapacity"
                    (change)="capacityChanged(ticketType.id, venueSectionAvailable - this.amountOfLocalGACapacity)">
                </div>
              </div>
            </td>
            <td class="button">
              <cm-button data-button-type="icon" data-icon="add"
                [attr.disabled]="(venueSectionAvailable - this.amountOfLocalGACapacity) - productsAmountSelected[ticketType.id] <= 0 ? true : undefined"
                (click)="alterTicketTypeAmount(ticketType.id, '+')">
              </cm-button>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>

<div class="row footer">
  <div class="col-12 text-right m-t-16">
    <cm-button data-button-style="cta" [attr.data-label]="'Venue_Section.Add' | trans"
      [attr.disabled]="totalItems === 0 ? true : null" (click)="addCapacityOrder()">
    </cm-button>
  </div>
</div>

